import { reactive, onMounted, getCurrentInstance } from "vue";
import clipboard3 from "vue-clipboard3";
import { ElMessage } from "element-plus";
export default {
  name: "Recharge",
  setup() {
    const {
      toClipboard
    } = clipboard3();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      amount: 0,
      setIsShow: false,
      bankList: []
    });
    onMounted(() => {
      checkBalance();
      selectBankList();
    });
    //查询钱包余额
    const checkBalance = async () => {
      data.amount = ((await globalProperties.$api.checkBalance()) || 0) / 100;
    };

    //查询充值对公银行
    const selectBankList = async () => {
      data.bankList = await globalProperties.$api.selectBankList();
    };
    const setIsShow = () => {
      data.isShow = !data.isShow;
    };
    //复制
    const copy = async value => {
      await toClipboard(value);
      ElMessage({
        type: "success",
        message: "已复制"
      });
    };
    return {
      data,
      setIsShow,
      copy
    };
  }
};